package com.eladfinish.bible.contest.ui.components.buttons

import androidx.compose.foundation.border
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.heightIn
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.Button
import androidx.compose.material3.ButtonDefaults
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import com.eladfinish.bible.contest.SharedRes
import com.eladfinish.bible.contest.colorPrimaryDark
import com.eladfinish.bible.contest.strokeColor
import dev.icerock.moko.resources.compose.colorResource

@Composable
fun PrimaryButtonText(
    modifier: Modifier = Modifier,
    text: String,
    borderWidth: Int = 1,
    enabled: Boolean = true,
    onClick: () -> Unit,
) {
    Button(
        enabled = enabled,
        elevation = ButtonDefaults.buttonElevation(
            defaultElevation = 0.dp,
            pressedElevation = 8.dp,
            disabledElevation = 0.dp
        ),
        onClick = onClick,
        modifier = modifier
            .fillMaxWidth()
            .heightIn(min = 48.dp)
            .border(
                width = borderWidth.dp,
                color = colorResource(resource = SharedRes.colors.strokeColor),
                shape = RoundedCornerShape(12.dp),
            ),
        shape = RoundedCornerShape(12.dp),
        colors = ButtonDefaults.buttonColors(
            containerColor = colorResource(resource = SharedRes.colors.colorPrimaryDark),
        ),
    ) {
        Text(
            text = text,
            fontSize = 18.sp,
            style = MaterialTheme.typography.labelLarge,
            textAlign = TextAlign.Center,
            color = Color.White,
        )
    }
}
